// let gtmLoaded = false

export function trackEvent ({ category = '-', action = '-', label = '-', value = '-', event = 'ga_event'} = {}) {
	const eventData = {};
	if (event !== '-') eventData.event = event;
	if (category !== '-') eventData.category = category;
	if (action !== '-') eventData.action = action;
	if (label !== '-') eventData.label = label;
	if (value !== '-') eventData.value = value;

	console.log(eventData);

	if (window.dataLayer) {
		window.dataLayer.push(eventData);
	}
}

export function trackGa4Event ({ ga4Parameter1Name = '-', ga4Parameter1Value = '-', ga4Parameter2Name = '-', ga4Parameter2Value = '-', ga4Event = '-', event = 'ga4_event' } = {}) {
    const eventData = {};
    if (event !== '-') eventData.event = event;
    if (ga4Parameter1Name !== '-') eventData.ga4_parameter_1_name = ga4Parameter1Name;
    if (ga4Parameter1Value !== '-') eventData.ga4_parameter_1_value = ga4Parameter1Value;
    if (ga4Parameter2Name!== '-') eventData.ga4_parameter_2_name = ga4Parameter2Name;
    if (ga4Parameter2Value !== '-') eventData.ga4_parameter_2_value = ga4Parameter2Value;
    if (ga4Event !== '-') eventData.ga4_event = ga4Event;
    
    console.log(eventData);

    if (window.dataLayer) {
        window.dataLayer.push(eventData);
    }
}

export function launchGTM (gtmID) {
	// if(gtmLoaded) return
	window.dataLayer = window.dataLayer || [];
	// gtmLoaded = true;
	console.log('launch GTM');
	/*eslint-disable */
	(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
	new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
	j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
	'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
	})(window,document,'script','dataLayer', gtmID );
	/* eslint-enable */
}